import React, { useEffect, useState } from "react";
import useApi from "../utils/UseAPI";
import Spinner from "react-bootstrap/Spinner";
import SanitizeHref from "../utils/SanitizeHref";

function DPRForms() {
  const { error, processing, getRequest } = useApi();
  const [general, setGeneral] = useState([]);
  const [dDID, setDDID] = useState([]);
  const [bH, setBH] = useState([]);
  const [bHObjective, setBHObjective] = useState([]);
  const [sA, setSA] = useState([]);
  const [sAObjective, setSAObjective] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      const [data, status] = await getRequest(null, "document/dpr");
      if (status === 200) {
        FormFilter(data.data.documents);
      } else {
        console.error(error);
      }
    };
    fetchLinks();
  }, []);

  function FormFilter(formsData) {
    const filters = {
      general: [], dDID: [], bH: [], sA: [], sAObjective: [], bHObjective: []
    };
    
    formsData.forEach((form) => {
      if (form.categoryId === 1 && form.division === "DID") filters.dDID.push(form);
      else if (form.categoryId === 8 && form.division === "BH") filters.bH.push(form);
      else if (form.categoryId === 1 && form.division === "SA") filters.sA.push(form);
      else if (form.categoryId === 10 && form.division === "SA") filters.sAObjective.push(form);
      else if (form.categoryId === 9 && !form.division) filters.general.push(form);
      else if (form.categoryId === 2 && form.division === "BH") filters.bHObjective.push(form);
    });

    setGeneral(filters.general);
    setDDID(filters.dDID);
    setBH(filters.bH);
    setSA(filters.sA);
    setBHObjective(filters.bHObjective);
    setSAObjective(filters.sAObjective);
  }

  const BuildHref = (url) => {
    const noPrefix = ["pi", "db-forms", "dataguide", "dpr-forms"].includes(url);
    const href = noPrefix ? url : `documents/cmhc/dpr/documents/${url}`;
    return SanitizeHref(href);
  };

  return (
    <div className="container py-4">
      <h2 id="general-info" className="mb-4 border-bottom pb-2">General Information</h2>
      <div className="row g-3 mb-5">
        {processing ? (
          <div className="col-12 text-center p-3" role="status">
            <Spinner animation="border" variant="success" />
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          general.map((data, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <a href={BuildHref(data.url)} className="d-block p-3 border rounded bg-light text-decoration-none hover-shadow h-100">
                📄 {data.name}
              </a>
            </div>
          ))
        )}
      </div>

      <h2 className="mb-4 border-bottom pb-2">Instructions and Objectives</h2>

      {[
        { title: "Developmental and Intellectual Disabilities", data: dDID, objectives: [] },
        { title: "Mental Health", data: bH, objectives: bHObjective },
        { title: "Substance Abuse", data: sA, objectives: sAObjective }
      ].map((division, idx) => (
        <section key={idx} className="mb-4 p-4 border rounded shadow-sm bg-white">
          <h3 className="h5 text-primary mb-3">{division.title}</h3>
          <div className="row">
            <div className="col-md-6">
              <h4 className="h6 fw-bold mb-2">Instructions</h4>
              <ul className="list-unstyled ms-2">
                {/* DUBBOT FIX: Ensure the list is never empty and contains only <li> */}
                {division.data.length > 0 ? (
                  division.data.map((item, i) => (
                    <li key={i} className="mb-2">
                      <a href={BuildHref(item.url)} className="text-decoration-none">{item.name}</a>
                    </li>
                  ))
                ) : (
                  <li className="text-muted small">No instructions available.</li>
                )}
              </ul>
            </div>
            
            {division.objectives.length > 0 && (
              <div className="col-md-6 border-start ps-md-4">
                <h4 className="h6 fw-bold mb-2">Objectives</h4>
                <ul className="list-unstyled ms-2">
                  {division.objectives.map((item, i) => (
                    <li key={i} className="mb-2">
                      <a href={BuildHref(item.url)} className="text-decoration-none">{item.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </section>
      ))}
    </div>
  );
}

export default DPRForms;
